export const IP_CONSENT_COOKIE_NAME = "mis-user-ip-consent-provided";
